export enum Environment {
  Dev = 1,
  Stage = 2,
  Prod = 3,
}
